<template>
  <div class="h-full bg-sidebar text-sidebar-foreground transition-all duration-300 flex-shrink-0 flex flex-col"
       :class="[isCollapsed ? 'w-16' : 'w-64']">
    <div class="p-4 border-b border-sidebar-border flex items-center justify-between">
      <div class="flex items-center justify-center" :class="[isCollapsed ? 'w-full' : 'mb-2']">
        <router-link to="/">
          <img src="../assets/Fraport_Logo_Slovenija.svg" alt="Fraport Slovenija Logo" class="h-12 w-auto">
        </router-link>
      </div>
      <h2 v-if="!isCollapsed" class="text-xl font-semibold text-center">Navigation</h2>
      <button @click="toggleCollapse" class="p-1 rounded-md hover:bg-sidebar-accent transition-colors duration-200">
        <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path v-if="isCollapsed" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7"></path>
          <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7"></path>
        </svg>
      </button>
    </div>
    <nav class="mt-5 flex-grow">
      <ul>

        <!-- Forecasting for Planners - Only visible to PLANNER -->
        <li v-if="userData?.business_role === BusinessRole.PLANNER" class="mb-2">
          <router-link
            to="/forecasting-planners"
            class="flex items-center px-4 py-3 hover:bg-sidebar-accent transition-colors duration-200"
            :class="{ 'bg-sidebar-accent': activeItem === 'forecasting-planners', 'justify-center': isCollapsed }"
          >
            <svg class="h-5 w-5" :class="[isCollapsed ? '' : 'mr-3']" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
            </svg>
            <span v-if="!isCollapsed">Forecasting for Planners</span>
          </router-link>
        </li>
        <!-- Forecasting for PCO - Only visible to HEAD_OF_PCO and CONTROLLER -->
        <li v-if="userData?.business_role === BusinessRole.HEAD_OF_PCO || userData?.business_role === BusinessRole.CONTROLLER" class="mb-2">
          <router-link
            to="/forecasting-pco"
            class="flex items-center px-4 py-3 hover:bg-sidebar-accent transition-colors duration-200"
            :class="{ 'bg-sidebar-accent': activeItem === 'forecasting-pco', 'justify-center': isCollapsed }"
          >
            <svg class="h-5 w-5" :class="[isCollapsed ? '' : 'mr-3']" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
            </svg>
            <span v-if="!isCollapsed">Forecasting for PCO</span>
          </router-link>
        </li>

        <!-- Chatbot -->
        <li class="mb-2">
          <router-link
            to="/chatbot"
            class="flex items-center px-4 py-3 hover:bg-sidebar-accent transition-colors duration-200"
            :class="{ 'bg-sidebar-accent': activeItem === 'chatbot', 'justify-center': isCollapsed }"
          >
            <svg class="h-5 w-5" :class="[isCollapsed ? '' : 'mr-3']" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
            </svg>
            <span v-if="!isCollapsed">Chatbot</span>
          </router-link>
        </li>

        <!-- Administration - Only visible to HEAD_OF_PCO -->
        <li v-if="userData?.business_role === BusinessRole.HEAD_OF_PCO" class="mb-2">
          <router-link
            to="/administration"
            class="flex items-center px-4 py-3 hover:bg-sidebar-accent transition-colors duration-200"
            :class="{ 'bg-sidebar-accent': activeItem === 'administration', 'justify-center': isCollapsed }"
          >
            <svg class="h-5 w-5" :class="[isCollapsed ? '' : 'mr-3']" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
            </svg>
            <span v-if="!isCollapsed">Administration</span>
          </router-link>
        </li>
      </ul>
    </nav>
    
    <!-- User Profile Section -->
    <div class="mt-auto border-t border-sidebar-border p-4">
      <div class="flex items-center" :class="{ 'justify-center': isCollapsed }">
        
          <div class="h-10 w-10 rounded-full bg-primary/20 flex items-center justify-center overflow-hidden" :class="[isCollapsed ? '' : 'mr-3']">
            <span v-if="!userData || !userData.avatar" class="text-sm font-semibold text-primary">
              {{ userInitials }}
            </span>
            <img v-else :src="userData.avatar" alt="User avatar" class="h-full w-full object-cover" />
          </div>
          <div v-if="!isCollapsed" class="flex-1 min-w-0">
            <p class="text-sm font-medium truncate">{{ userData?.business_role ? formatBusinessRole(userData.business_role as BusinessRole) : 'Not set' }}</p>
            <p class="text-xs text-sidebar-foreground/70 truncate">{{ userData?.name }}</p>
          </div>
        

        <!-- Settings Button - Visible when sidebar is expanded -->
        <button
          v-if="!isCollapsed"
          @click="navigateTo('user-settings')"
          class="ml-2 p-2 rounded-md hover:bg-sidebar-accent transition-colors duration-200 flex items-center justify-center"
          title="Settings"
        >
          <svg class="h-5 w-5 text-sidebar-foreground/70" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
          </svg>
        </button>

        <!-- Logout Button - Visible when sidebar is expanded -->
        <button
          v-if="!isCollapsed"
          @click="handleLogout"
          class="ml-2 p-2 rounded-md hover:bg-sidebar-accent transition-colors duration-200 flex items-center justify-center"
          title="Logout"
        >
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
          </svg>
        </button>
        
        <!-- Logout Button - Visible when sidebar is collapsed -->
        <button
          v-if="isCollapsed"
          @click="handleLogout"
          class="mt-2 p-2 rounded-md hover:bg-sidebar-accent transition-colors duration-200 flex items-center justify-center"
          title="Logout"
        >
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, PropType } from 'vue';
import { logger } from '@/services/logger';
import { BusinessRole, formatBusinessRole } from '@/types/businessRole';

interface UserData {
  name: string;
  role?: string;
  avatar: string | null;
  business_role?: string;
}

export default defineComponent({
  name: 'SideNav',
  props: {
    activeItem: {
      type: String as PropType<string>,
      default: 'home'
    },
    userData: {
      type: Object as PropType<UserData>,
      default: () => ({
        name: 'User',
        role: 'User',
        avatar: null,
        business_role: ''
      })
    }
  },
  emits: ['navigate', 'logout', 'toggle-collapse'],
  setup(props, { emit }) {
    const isCollapsed = ref(false);
    
    const userName = computed(() => props.userData?.name || 'User');
    const userRole = computed(() => props.userData?.role || props.userData?.business_role || 'User');
    const userInitials = computed(() => {
      if (!props.userData?.name) return 'U';
      return props.userData.name
        .split(' ')
        .map(name => name.charAt(0))
        .join('')
        .toUpperCase();
    });
    function toggleCollapse() {
      isCollapsed.value = !isCollapsed.value;
      emit('toggle-collapse', isCollapsed.value);
    }
    function handleLogout() {
      logger.info('User initiated logout');
      emit('logout');
    }
    
    function navigateTo(navItem: string) {
      logger.info('Navigating to', { navItem });
      emit('navigate', navItem);
    }
    
    
    
    return {
      isCollapsed,
      userName,
      userRole,
      userInitials,
      toggleCollapse,
      handleLogout,
      navigateTo,
      BusinessRole,
      formatBusinessRole
    };
  }
});
</script>
